import { accountApi } from '@/api'
import { useAuth } from '@/composables/auth/useAuth'
import { useMainStore } from '@/stores/main'

export default defineNuxtPlugin(() => {
  const { $request } = useNuxtApp()
  const config = useRuntimeConfig()
  const store = useMainStore()
  const auth = useAuth()

  function toggleButton(buttonType, action) {
    const { Telegram } = window || {}
    const tgWebApp = Telegram?.WebApp || {}
    const tgButton = tgWebApp[buttonType] || {}
    if (action === 'show') {
      tgButton.show()
    } else if (action === 'hide') {
      tgButton.hide()
    }
  }

  function setButtonClickEvt(buttonType, event) {
    const { Telegram } = window || {}
    const tgWebApp = Telegram?.WebApp || {}
    const tgButton = tgWebApp[buttonType] || {}
    tgButton.onClick(event)
  }

  function requestFullScree() {
    const { Telegram } = window || {}
    const tgWebApp = Telegram?.WebApp || {}
    tgWebApp.requestFullscreen()
  }

  async function bindingTelegram(loginType, authData, isSignature) {
    try {
      store.setLoading({ thirdPartyLogin: true })

      await $request.send(
        accountApi.applyBinding({
          provider: 'telegram',
          loginType,
          additionalUserInfo: authData,
          isSignature,
        })
      )

      // 跑完之後更新綁定資料
      window.dispatchEvent(new CustomEvent('third-party-bound'))
    } catch (error) {
      console.error('Telegram Bind Fail', error)
    } finally {
      store.setLoading({ thirdPartyLogin: false })
    }
  }
  function tgLogin(loginType, isBinding = false) {
    const { Telegram } = window || {}
    const tgWebApp = Telegram?.WebApp || {}
    if (loginType === 'WebApp') {
      const { initDataUnsafe = null, initData = null } = tgWebApp || {}

      if (!initDataUnsafe && !initData) {
        console.error('No Telegram WebApp init data found!')
        return
      }

      // 綁定
      if (isBinding) {
        if (initDataUnsafe?.signature) {
          bindingTelegram(loginType, initData, true)
        } else {
          bindingTelegram(loginType, initDataUnsafe, false)
        }
        return
      }

      // 登入
      if (initDataUnsafe?.signature) {
        // 新版的 Telegram 使用者資料與驗證方式
        callTelegramLogin(loginType, initData, true)
      } else {
        // 舊版的 Telegram 使用者資料與驗證方式
        callTelegramLogin(loginType, initDataUnsafe, false)
      }
    } else if (loginType === 'Widget') {
      const TELEGRAM_BOT_TOKEN = config.public.telegramBotToken
      const bot_id = TELEGRAM_BOT_TOKEN.split(':')[0]

      window.Telegram.Login.auth({ bot_id, request_access: 'write', embed: 1 }, (user) => {
        // 綁定
        if (isBinding) {
          bindingTelegram(loginType, user, false)
          return
        }
        // 登入
        callTelegramLogin(loginType, user, false)
      })
    }
  }

  async function callTelegramLogin(loginType, authData, isSignature) {
    try {
      store?.setLoading({ thirdPartyLogin: true })
      await auth.loginWithTelegram({ loginType, additionalUserInfo: authData, isSignature })
    } catch (error) {
      console.error('Telegram Login Fail !', error)
    } finally {
      store?.setLoading({ thirdPartyLogin: false })
    }
  }

  return {
    provide: {
      tgWebAppShowBtn: (buttonType) => toggleButton(buttonType, 'show'),
      tgWebAppHideBtn: (buttonType) => toggleButton(buttonType, 'hide'),
      tgWebAppSetBtnEvt: (buttonType, event) => setButtonClickEvt(buttonType, event),
      tgWebAppFullScreen: () => requestFullScree(),
      tgLogin,
    },
  }
})
